// extracted by mini-css-extract-plugin
export default {"root":"FaqList-root","item":"FaqList-item","heading":"FaqList-heading","question":"FaqList-question","questionHeading":"FaqList-questionHeading","partnerLogo":"FaqList-partnerLogo"};